import * as React from 'react'
import * as Container from "../../container/container";
import { StaticImage } from "gatsby-plugin-image";

const Novel = (key) => {
    return (
        <Container.Fullwidth key={key.toString() + 'slider'}>
            <Container.Novel id={key} sliderTitleId="nodelTitle">
                <div className="bg-grey">
                    <p>1978 Ermershausen</p>
                    <h2>In der Nacht auf den 19. Mai 1978 in Ermershausen …</h2>
                    <StaticImage src="../../../../static/images/Ermershausen/Novel/Szene_1_Bild_1.png" placeholder="none" alt=""/>
                </div>
                <StaticImage src="../../../../static/images/Ermershausen/Novel/Szene_1_Bild_2.png" placeholder="none" alt=""/>
                <StaticImage src="../../../../static/images/Ermershausen/Novel/Szene_1_Bild_3.png" placeholder="none" alt=""/>
                <StaticImage src="../../../../static/images/Ermershausen/Novel/Szene_1_Bild_4.png" placeholder="none" alt=""/>
                <div className="bg-grey">
                    <h2>Der Dorfplatz in einem der darauffolgenden Jahre …</h2>
                    <StaticImage src="../../../../static/images/Ermershausen/Novel/Szene_2_Bild_1.png" placeholder="none" alt=""/>
                </div>
            </Container.Novel>
        </Container.Fullwidth>
    )
}

export default Novel

